import { useState } from 'react';
import { useRouter } from 'next/router';
import { Mail, ArrowRight, AlertCircle } from 'lucide-react';
import { subscribeToBrevo } from '../helpers/emailSignup';

export default function BottomCTA() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const router = useRouter();

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validate email
    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);

    try {
      const result = await subscribeToBrevo(email);
      if (result.success) {
        router.push('/thank-you');
      } else {
        setError(result.error || 'Failed to subscribe. Please try again.');
      }
    } catch (err) {
      console.error('Subscription error:', err);
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id='early-access' className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl bg-gradient-to-br from-slate-900 to-slate-800 text-white p-8 sm:p-12">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center space-x-3 bg-white/10 px-4 py-2 rounded-full mb-8">
              <Mail className="w-5 h-5 text-sky-400" />
              <span className="text-sm font-medium text-sky-400">Get ready for eIDAS 2.0</span>
            </div>

            <h2 className="text-4xl font-bold mb-6">
              Ready to Transform Your Business Identity Management?
            </h2>
            
            <p className="text-xl text-slate-300 mb-8">
              Join BusinessWallet.eu today and get early access to our platform. Be among the first to experience seamless digital identity management that's fully compliant with eIDAS 2.0.
            </p>

            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
              <div className="flex-grow relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError(''); // Clear error when user types
                  }}
                  placeholder="Enter your email"
                  className={`w-full px-4 py-4 rounded-xl bg-white/10 border ${
                    error ? 'border-red-400' : 'border-white/20'
                  } text-white placeholder-slate-400 focus:ring-2 focus:ring-sky-500 focus:outline-none`}
                  required
                  aria-label="Email address"
                  aria-invalid={error ? 'true' : 'false'}
                  aria-describedby={error ? 'email-error' : undefined}
                />
                {error && (
                  <div className="absolute -bottom-6 left-0 right-0 flex items-center justify-center space-x-1 text-red-400 text-sm">
                    <AlertCircle className="w-4 h-4" />
                    <span id="email-error" role="alert">{error}</span>
                  </div>
                )}
              </div>
              <button
                type="submit"
                disabled={isLoading}
                className="bg-gradient-to-r from-sky-500 to-indigo-500 text-white px-8 py-4 font-medium hover:opacity-90 transition-opacity flex items-center justify-center space-x-2 rounded-xl shadow-sm whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                aria-label={isLoading ? 'Subscribing...' : 'Subscribe to newsletter'}
              >
                <span>{isLoading ? 'Subscribing...' : 'Get Started Now'}</span>
                {!isLoading && <ArrowRight className="w-4 h-4" />}
              </button>
            </form>


          </div>
        </div>
      </div>
    </section>
  );
} 